import { createApp } from 'vue'
import '@coreui/coreui/dist/css/coreui.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './style.css'
import App from './App.vue'

createApp(App).mount('#app')
